import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import cns from 'classnames';
import { Text } from '../common';
import BaseCalendarButton from '@components/common/BaseCalendarButton';

const ButtonWrapper = styled(BaseCalendarButton)`
  border: 0;
  border-right: 1px solid rgb(216, 216, 216);

  &:last-child {
    border-right: 0;
  }
`;

function ScheduleButton(props) {
  const {
    id,
    row,
    title,
    specialItem,
    renderSpecialItem,
    disabledExtractor,
    filledExtractor,
    errorExtractor,
    selected,
    disabled,
    reserved,
    ...restProps
  } = props;
  const titleColor = selected ? 'white' : undefined;

  const renderContent = () => {
    if (!!specialItem && renderSpecialItem) {
      return renderSpecialItem(specialItem, disabled, selected);
    }

    if (title) {
      return (
        <Text fontSize={2} color={!disabled ? titleColor : 'grey.1'}>
          {title}
        </Text>
      );
    }

    if (reserved) {
      return (
        <Text fontSize={[0, 2]} color={!disabled ? titleColor : 'grey.1'}>
          Reserved
        </Text>
      );
    }

    return null;
  };

  const defaultDisabledExtractor = () => disabled;
  const defaultFilledExtractor = () => !!specialItem;
  const defaultErrorExtractor = () => false;

  const isDisabled = disabledExtractor
    ? disabledExtractor(row, id, specialItem, disabled, selected)
    : defaultDisabledExtractor();

  const isFilled = filledExtractor
    ? filledExtractor(row, id, specialItem, disabled, selected)
    : defaultFilledExtractor();

  const hasError = errorExtractor
    ? errorExtractor(row, id, specialItem, disabled, selected)
    : defaultErrorExtractor();

  return (
    <ButtonWrapper
      className={cns('schedule-button', {
        'schedule-button-disabled': isDisabled,
        'schedule-button-filled': isFilled || reserved
      })}
      dataAttributeDisabled={disabled}
      selected={selected}
      disabled={isDisabled || reserved}
      hasError={hasError}
      {...restProps}
      data-row-id={row}
      data-col-id={id}
    >
      {renderContent()}
    </ButtonWrapper>
  );
}

ScheduleButton.propTypes = {
  id: PropTypes.number,
  row: PropTypes.number,
  icon: PropTypes.string,
  title: PropTypes.string,
  selected: PropTypes.bool,
  disabled: PropTypes.bool,
  reserved: PropTypes.bool,
  specialItem: PropTypes.object,
  renderSpecialItem: PropTypes.func,
  disabledExtractor: PropTypes.func,
  filledExtractor: PropTypes.func,
  errorExtractor: PropTypes.func,
  onDrop: PropTypes.func
};

ScheduleButton.defaultProps = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center'
};

export default ScheduleButton;
